import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面 预约期 官网先展示预约
    {
      path: "/",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/home",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/news",
      component: () => import("./views/gw/news.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/news/m",
      component: () => import("./views/gw/news.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/content",
      component: () => import("./views/gw/content.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/content/m",
      component: () => import("./views/gw/content.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
    },
    // 备战盟
    {
      path: "/alliance/:type(m)?",
      component: () => import("./views/alliance/index.vue"),
    },
    // 下载
    {
      path: "/down/:version",
      meta: {
        title:
          "『三国志:九州覇業』の事前登録が絶賛受付中！事前登録で神将・趙雲を無料で入手、さらに初週で390連ガチャを豪華にプレゼント！",
        keywords:
          "三国志:九州覇業、九州覇業、九州制覇、三国群英伝、三国群英伝 九州制覇、三国群英伝 SLG、九州制覇 事前登録、九州制覇 事前ログイン、三国群英伝 スマホゲーム、正統派三国群英伝、三国志 戦略版、大三国志、三国志:真戦、三国志:覇道、三国謀定天下、ライズ・オブ・キングダムズ、三国、リアル三国、立体戦争、SLG、ストラテジーゲーム、リアルタイムストラテジー、RTS、スマホゲーム、無料ゲーム、リアルタイムストラテジー、リアルタイムバトル事前登録、事前ログイン、スマホゲーム事前登録、公式サイトでの予約開拓時に道路建設不要、道路建設不要SLG、瞬時城移転、建築物瞬時アップグレード、倍率付き掃討、無損失での武将交換、レベル共鳴、自由行軍、リアルな地形、3D三国、海陸空の戦場、武将共鳴、必中専用武器、ガチャロックなし、国戦、攻城、同盟結集、一般プレイヤー必プレイの良心SLG、疲れないSLG、390連ガチャ、 無料趙雲、2026年新作SLG、3Dサンドボックス戦略、戦争戦略スマホゲーム、洛陽争奪賞金戦、総額3000万争奪戦、賞金大会、スピードレース、ガチャ関羽、趙雲、諸葛亮、曹操、劉備、呂布、周瑜、貂蝉、武将育成、陣形配置、兵種相性、三国志スマホゲームおすすめ、JP三国志ゲーム、Giftcode",
        description:
          "今すぐ『三国志:九州覇業』を事前登録、神将・趙雲を無料で入手、初週で最大390連ガチャも無料！立体的な戦場、空陸連携による攻撃、平面を超えよ。武将レベルはすべて共有され、新編成で即座に戦闘を開始可能。自動攻城、同盟委託機能、夜間門限など、純粋な戦略を楽しもう！",
      },
      component: () => import("./views/down/index.vue"),
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/];

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, "");
  let wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
